import Checkbox from 'components/CustomCheckbox/CustomCheckbox.jsx';
import React from 'react';

import 'react-select/dist/react-select.css';

const CheckboxWidget = function (props) {
  return (
    <Checkbox
      number={props.id}
      label={props.schema.title}
      value={true}
      checked={props.value}
      onChange={() => props.onChange(!props.value)}
    />
  );
};

export default CheckboxWidget;



// WEBPACK FOOTER //
// ./src/lib/widget-checkbox.js